import React from 'react';
import { Navigation } from '../components/FormControls';
import { StepProps } from './sectionTypes';
import { formatPhone } from '../utils';

export const ResponsaveisStep = ({
  form,
  etapaCompleta,
  updateForm,
  input,
  onPrev,
  onNext,
  telefoneErro,
  validarTelefoneMae
}: StepProps & {
  telefoneErro: string;
  validarTelefoneMae: (value: string) => void;
}) => (
  <section className="form-section">
    <h2><span className="section-icon">💼</span>Filiação / Responsáveis</h2>
    <div className="form-group">
      <label htmlFor="nomeMae">Nome da Mãe ou Responsável *</label>
      <input id="nomeMae" type="text" required {...input('nomeMae')} />
    </div>
    <div className="form-row">
      <div className="form-group">
        <label htmlFor="telefoneMae">Telefone (WhatsApp obrigatório) *</label>
        <input id="telefoneMae" type="text" placeholder="(00) 00000-0000" required value={form.telefoneMae} onChange={(event) => validarTelefoneMae(event.target.value)} />
        {telefoneErro && <div className="error-message">{telefoneErro}</div>}
      </div>
      <div className="form-group">
        <label htmlFor="telefoneAdicionalMae">Telefone adicional</label>
        <input id="telefoneAdicionalMae" type="text" placeholder="(00) 00000-0000" value={form.telefoneAdicionalMae} onChange={(event) => updateForm('telefoneAdicionalMae', formatPhone(event.target.value))} />
      </div>
    </div>
    <div className="form-group">
      <label htmlFor="nomePai">Nome do Pai ou Responsável</label>
      <input id="nomePai" type="text" {...input('nomePai')} />
    </div>
    <div className="form-row">
      <div className="form-group">
        <label htmlFor="telefonePai">Telefone</label>
        <input id="telefonePai" type="text" placeholder="(00) 00000-0000" value={form.telefonePai} onChange={(event) => updateForm('telefonePai', formatPhone(event.target.value))} />
      </div>
      <div className="form-group">
        <label htmlFor="telefoneAdicionalPai">Telefone adicional</label>
        <input id="telefoneAdicionalPai" type="text" placeholder="(00) 00000-0000" value={form.telefoneAdicionalPai} onChange={(event) => updateForm('telefoneAdicionalPai', formatPhone(event.target.value))} />
      </div>
    </div>
    <Navigation disabled={!etapaCompleta[4]} onPrev={onPrev} onNext={onNext} />
  </section>
);
